module.exports = __webpack_public_path__ + "static/media/cswap-origins.0bc9a43f.svg";